import { createOpenaiAdapter } from './openai.js'
import { createGeminiAdapter } from './gemini.js'
import { createOllamaAdapter } from './ollama.js'

export const availableProviders = ['openai', 'gemini', 'ollama']

/**
 * Create provider adapters
 * @param {Object} clients - Raw client instances
 * @param {Object} clients.openaiClient
 * @param {Object} clients.geminiClient
 * @param {Object} clients.ollamaClient
 * @returns {Object} Provider adapters
 */
export function createProviders({ openaiClient, geminiClient, ollamaClient }) {
  return {
    openai: createOpenaiAdapter(openaiClient),
    gemini: createGeminiAdapter(geminiClient),
    ollama: createOllamaAdapter(ollamaClient),
  }
}
